import checkout from "./form";

const {
  formField: {
    // user page
    name,
    email,
    allLocations,
    role,
    phone,
    dob,
    photo,
    partnerPower,
    // user additional info
    partner,
    locations,
    location,
    balance,
    commission,
    promoCodes,
    locDestinations,
    reference,
    // additional curator info
    description,
    // photo,
    bio,
    languages,
    interests,
    // destinations,
    destinations,
    tickets,
  },
} = checkout;

const initialValues = {
  // user page
  [name.name]: "",
  [email.name]: "",
  [role.name]: "",
  [phone.name]: "",
  [dob.name]: "",
  [photo.name]: "",

  // user additional info
  [partner.name]: "",
  [allLocations.name]: false,
  [bio.name]: "",
  [languages.name]: [],
  [locations.name]: [],
  [location.name]: "",
  [partnerPower.name]: false,
  [balance.name]: 0,
  [commission.name]: 0,
  [promoCodes.name]: [],
  [locDestinations.name]: { location: "", destinations: "" || {} },
  // additional curator info
  // [photo.name]: "",
  [bio?.name]: "",
  [description?.name]: "",
  [languages?.name]: [],
  [interests?.name]: [],
  [destinations?.name]: {},
  [reference.name]: "",
  [tickets?.name]: [],
};

export default initialValues;
